<div class="back-to-top" [ngClass]="{ 'show-scrollTop': windowScrolled }">
  <button mat-raised-button (click)="backToTop()" id="btn-back-to-top">
    <img
      src="{{ 'assets/images/back-to-top.svg' | cheminAbsoluStatique }}"
      alt="{{ 'btn.scroll-to-top' | translate }}"
      width="25px"
      height="25px"
    />
  </button>
</div>
